<template>
  <div
    class="log-description-content markdown-description"
    v-html="guideData ? guideData : '暂无说明'"
  ></div>
</template>

<script>
// 日志说明 markdown 解析
var hljs = require('highlight.js');
import 'highlight.js/styles/github.css';

const mdHtml = require('markdown-it')({
  html: false, // Enable HTML tags in source
  xhtmlOut: false, // Use '/' to close single tags (<br />)
  breaks: false, // Convert '\n' in paragraphs into <br>
  langPrefix: 'language-', // CSS language prefix for fenced blocks
  linkify: true, // autoconvert URL-like texts to links
  typographer: true, // Enable smartypants and other sweet transforms
  highlight: function(str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return `<div class="hljs-wrapper"><pre class="hljs"><code>${
          hljs.highlight(lang, str, true).value
        }</code></pre></div>`;
      } catch (__) {
        /**/
      }
    }

    // 只有输入框才有选择文本的方法，所以此处添加一个 textarea
    return `<div class="hljs-wrapper"><pre class="hljs"><code>${mdHtml.utils.escapeHtml(
      str
    )}</code></pre><textarea class="copy-text">${mdHtml.utils.escapeHtml(
      str
    )}</textarea><span class="copy-btn">复制</span></div>`;
  }
});

export default {
  name: 'LogAccessGuideViewer',

  props: {
    dataSourceConfigData: {
      type: String
    }
  },

  data() {
    return {
      guideData: ''
    };
  },

  created() {
    this.onRenderData();
  },

  methods: {
    async onRenderData() {
      if (!this.dataSourceConfigData) {
        return;
      }

      this.guideData = mdHtml.render(this.dataSourceConfigData);
      await this.$nextTick();

      document.querySelector('.log-description-content').addEventListener('click', e => {
        const target = e.target;
        if (target.className === 'copy-btn') {
          target.previousSibling.select();
          document.execCommand('Copy');
          if (window.getSelection().focusNode) {
            this.$message.success('复制成功');
          } else {
            this.$message.error('复制失败');
          }
        }
      });
    }
  }
};
</script>
